import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: { focusTo: string | null } = {
  focusTo: null,
};
export const focusOnValidation = createSlice({
  name: 'button-validation',
  initialState,
  reducers: {
    setFocusTo: (state, action: PayloadAction<string | null>) => {
      state.focusTo = action.payload;
    },
  },
});
export const { setFocusTo } = focusOnValidation.actions;
export const focusOnValidationReducer = focusOnValidation.reducer;
